if (!customElements.get("discount-code")) {
  const GENERIC_CODE = "COLISHIELD26";

  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.hasDiscountCode = this.hasDiscountApplied();
      this.applyBtn = this.querySelector("#apply-discount-btn");
      this.discountCodeError = this.querySelector("#discount-code-error");
      this.discountCodeSuccess = this.querySelector("#discount-code-success");
      this.discountCodeRequired = this.querySelector("#discount-code-required");
      this.discountCodeInput = this.querySelector("#discount-code-input");
      this.discountCodeNote = this.querySelector(".discount-code__note");

      window.addEventListener("pageshow", (event) => {
        if (event.persisted || performance.navigation.type === performance.navigation.TYPE_BACK_FORWARD) {
          location.reload();
        }
      });
    }

    connectedCallback() {
      var self = this;

      console.log("🟡 DISCOUNT-CODE connectedCallback fired. Element:", this, "| Total discount-code elements on page:", document.querySelectorAll("discount-code").length);

      if (this.applyBtn) {
        this.applyBtn.addEventListener(
          "click",
          this.handleDiscountCodeAdd.bind(this)
        );
      }

      if (this.discountCodeInput) {
        this.discountCodeInput.addEventListener(
          "keypress",
          this.handleKeyPress.bind(this)
        );
      }

      document
        .querySelectorAll(
          'button[name="checkout"], .additional-checkout-buttons, .cart__dynamic-checkout-buttons[disabled]'
        )
        .forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault();
            this.handleCheckoutProceeded(); // Solo si `this` es válido aquí
          });
        });

      setInterval(() => {
        this.toggleCheckoutButton(this.hasDiscountCode);
      }, 200);
    }

    handleKeyPress(e) {
      if (e.code === "Enter" || e.code === "NumpadEnter") {
        this.handleDiscountCodeAdd(e);
      }
    }

    handleDiscountCodeAdd(e) {
      e.preventDefault();

      let checkoutContainer = document.createElement("div");
      document.body.appendChild(checkoutContainer);

      this.applyDiscount(this.discountCodeInput.value);
    }

    handleCheckoutProceeded() {
      console.log("🔵 CHECKOUT clicked - fetching cart...");
      fetch("/cart.js", {})
        .then((res) => res.json())
        .then((cart) => {
          const hasDiscount = Array.from(cart?.discount_codes).some(
            (el) => el.applicable
          );

          const hasSubscription = cart?.items?.some(
            (item) => item.selling_plan_allocation
          );

          const result = hasDiscount ? true : false;

          console.log("🔵 CHECKOUT check → discount_codes:", cart?.discount_codes, "| hasDiscount:", hasDiscount, "| result:", result, "| redirecting to /checkout regardless");

          this.toggleCheckoutButton(result);
          if (!result) this.showMessage("required");
          window.location.href = "/checkout"
        });
    }

    applyDiscount(code) {
      if (this.applyBtn) {
        this.applyBtn.innerHTML = "APPLYING";
        this.applyBtn.style.pointerEvents = "none";
        this.toggleCheckoutButton(false);
      }

      fetch("/payments/config", { method: "GET" })
        .then((response) => response.json())
        .then((_data) => {
          fetch("/cart.js", {})
            .then((res) => res.json())
            .then((_data) => {
              fetch(`/discount/${code}?redirect=/cart.json`, {
                method: "GET",
                credentials: "include",
              }).then((res) => {
                fetch(res.url)
                  .then((res) => res.json())
                  .then((data) => {
                    this.proccessResponse(code, data);
                  })
                  .finally(() => {
                    this.discountCodeInput.value = "";

                    if (this.applyBtn) {
                      this.applyBtn.innerHTML = "APPLY YOUR VET CODE";
                      this.applyBtn.style.pointerEvents = "all";
                    }

                    fetch("/cart.js", {})
                      .then((res) => res.json())
                      .then((cart) => {
                        this.proccessResponse(code, cart);
                      });
                  });
              });
            });
        });
    }

    hasDiscountApplied() {
      fetch("/cart.js", {})
        .then((res) => res.json())
        .then((cart) => {
          const codes = Array.from(cart?.discount_codes || []);
          const hasDiscount = codes.some((el) => el.applicable);
          const hasGenericCode = codes.some(
            (el) => el.code.toUpperCase() === GENERIC_CODE && el.applicable
          );

          const result = hasDiscount ? true : false;
          this.toggleCheckoutButton(result);

          if (hasGenericCode) {
            this.hideVetCodeActions();
          } else {
            const actions = this.querySelector(".discount-code__actions");
            if (actions) actions.classList.remove("hidden");
          }

          return result;
        });
    }

    hideVetCodeActions() {
      const actions = this.querySelector(".discount-code__actions");
      if (actions) actions.remove();
    }

    proccessResponse(code, data) {
      const isRedirect = Array.from(data?.discount_codes).some(
        (el) => el.code.toLowerCase() == code.toLowerCase() && el.applicable
      );

      if (isRedirect) {
        this.showMessage();
        this.toggleCheckoutButton(true);

        this.discountCodeNote.value = code;
        this.discountCodeInput.value = "";
        this.showMessage("success");
        this.hasDiscountCode = true;
      } else {
        this.showMessage("error");
        this.toggleCheckoutButton(false);
        this.hasDiscountCode = false;
      }

      setTimeout(() => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "discount-code",
        });
      }, 500);

      if (Shopify.cart) {
        Shopify?.cart.update();
      }
    }

    showMessage(type) {
      const types = ["error", "success", "required"];
      types.forEach((key) => {
        this[
          `discountCode${key.charAt(0).toUpperCase() + key.slice(1)}`
        ].style.display = key === type ? "block" : "none";
      });
    }

    toggleCheckoutButton(enabled) {
      if (enabled == undefined) return;

      if (!enabled) {
        console.log("🔴 toggleCheckoutButton(FALSE) → locking checkout + blocking back button");
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
          history.go(1);
        };
      }

      document
        .querySelectorAll(
          'button[name="checkout"], .additional-checkout-buttons, .cart__dynamic-checkout-buttons[disabled]'
        )
        .forEach((button) => {
          button.toggleAttribute("disabled", !enabled);
          button.style.pointerEvents = enabled ? "all" : "none";
          button.style.opacity = enabled ? "1" : "0.5";
        });
    }

    hideDiscounts() {
      document
        .querySelectorAll(".discounts.list-unstyled")
        .forEach((discount) => {
          discount.replaceChildren();
        });
    }
  }

  customElements.define("discount-code", DiscountCode);
}